import React, { useState } from 'react';
import { useNavigate, Link, Navigate } from 'react-router-dom';
import { auth } from '../lib/api';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { useToast } from '../hooks/use-toast';
import { Lock, Mail, ArrowLeft, Loader2 } from 'lucide-react';

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { toast } = useToast();

  if (auth.isAuthenticated()) {
    return <Navigate to="/admin" replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await auth.login(email, password);
      toast({ title: 'Welcome back!', description: 'Login successful' });
      navigate('/admin');
    } catch (err) {
      const msg = err?.response?.data?.detail || 'Login failed. Please check credentials.';
      toast({ title: 'Login failed', description: msg, variant: 'destructive' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#fff7e6] via-white to-[#ffeacb] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-gray-600 hover:text-[#f7941e] mb-6">
          <ArrowLeft className="w-4 h-4" /> Back to website
        </Link>
        <div className="bg-white rounded-2xl shadow-2xl p-8 border border-[#f4e6c6]">
          <div className="text-center mb-6">
            <div className="w-16 h-16 mx-auto rounded-2xl bg-gradient-to-br from-[#f7941e] to-[#e67e00] flex items-center justify-center mb-3 shadow-lg">
              <Lock className="w-7 h-7 text-white" />
            </div>
            <h1 className="font-display text-2xl uppercase tracking-wide text-gray-900">Admin Login</h1>
            <p className="text-sm text-gray-500 mt-1">Ess Bee Heaters Pvt. Ltd.</p>
          </div>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <div className="relative mt-1">
                <Mail className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                <Input id="email" type="email" required value={email} onChange={e => setEmail(e.target.value)} className="pl-9" placeholder="admin@essbeeheaters.com" />
              </div>
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <div className="relative mt-1">
                <Lock className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                <Input id="password" type="password" required value={password} onChange={e => setPassword(e.target.value)} className="pl-9" placeholder="••••••••" />
              </div>
            </div>
            <button type="submit" disabled={loading} className="btn-brand w-full justify-center disabled:opacity-60">
              {loading ? <><Loader2 className="w-4 h-4 animate-spin" /> Signing in...</> : 'Sign In'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
